import { internalODataFetch, internalFetch } from "./servicesHelpers";

const technicianServices = {
    getTechnicians: (token, vendorNumber, keycloakID) => {
        const requestInit = {
            method: "GET",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = `/fetchAllTechs/${keycloakID}`;
        return internalODataFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
        // const expand = 'skills,contracts';
        // // const URI = `/Technicians?$format=json&$expand=${expand}` + (vendorNumber ? `&$filter=vendorNumber eq \'${vendorNumber}\' and roleJobTitle_en eq 'Contractor Labourer'` : '');
        // return internalFetch(process.env.REACT_APP_TECHNICIAN_API_URL + '/fetchAllTechs/' + keycloakID + '/', requestInit).then(({ err, result }) => {
        //             if (err === null) {
        //                 result = result.body;
        //             }
        //             return { err, result }
        //         }) ;
    },

    getTechnician: (token, keycloakID) => {
        const requestInit = {
            method: "GET",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = `/fetchTechnician/${keycloakID}`;
        return internalODataFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
        // return internalODataFetch(process.env.REACT_APP_TECHNICIAN_API_URL + '/Technicians?$format=json&$filter=relatedKeycloakUserId eq \'' + keycloakID + '\'', requestInit);
    },

    getTechnicianBySkill: (token, skillId) => {
        const requestInit = {
            method: "GET",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        return internalODataFetch(process.env.REACT_APP_TECHNICIAN_API_URL + "/Skills(" + skillId + ")/technician", requestInit);
    },

    getContracts: (token, vendorNumber) => {
        const requestInit = {
            method: "GET",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = `/fetchContracts/${vendorNumber}`;
        return internalODataFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
        // const URI = `/Contracts?$format=json&$filter=vendorNumber eq '${vendorNumber}'`;
        // return internalODataFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
    },
    getSkills: (token) => {
        const requestInit = {
            method: "GET",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = `/fetchAllSkills`;
        return internalODataFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
        // const URI = `/Skills?$format=json`;
        // return internalODataFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
    },

    createTechnician: (token, technician) => {
        const requestInit = {
            body: technician,
            method: "POST",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = "/createUser";
        return internalFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
    },

    editTechnician: (token, technician) => {
        const requestInit = {
            body: technician,
            method: "POST",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = "/editUser";
        return internalFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
    },

    deactivateTechnician: (token, request) => {
        const requestInit = {
            body: JSON.stringify(request),
            method: "POST",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = "/updateUserStatus";
        return internalFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
    },
    isTechnicianEnabled: (token, id) => {
        const requestInit = {
            method: "GET",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = "/isUserActive/" + id;
        return internalFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
    },
};

export default technicianServices;
